import { Camera } from '../models/ICamera';
import { Browser, MobileOS } from '../models/IDevice';
import { ApiCall } from './ApiCall';
import { DeviceInfo } from './DeviceInfo';
import { LoggerService } from './LoggerService';
import store from './store';

export class Cameras {
  public static mp4MimeType = { type: 'video/mp4', codec: 'codecs:h264', extension: 'mp4', mime: 'video/mp4;codecs:h264' };
  public static webmMimeType = { type: 'video/webm', codec: 'codecs=vp8', extension: 'webm', mime: 'video/webm;codecs=vp9' };

  static async GetCameras(deviceInfo: DeviceInfo) {
    var allDevices: Camera[] = [];

    // if (deviceInfo.isAppleDevice) {
    //   //@ts-ignore
    //   navigator.audioSession.type = 'play-and-record';
    // }
    const devices = await navigator.mediaDevices.enumerateDevices();
    const videoDevices = devices.filter(device => device.kind === 'videoinput');

    for (const device of videoDevices) {
      const updatedConstraints = this.GetConstraints(device.deviceId, deviceInfo, false, false);
      const stream = await navigator.mediaDevices.getUserMedia(updatedConstraints);
      stream.getVideoTracks().forEach(track => {
        if (deviceInfo.browser.name === Browser.Firefox) {
          const settings: MediaTrackSettings | any = track.getSettings();
          let facingMode = settings.facingMode && settings.facingMode.length > 0 ? settings.facingMode[0] : '';
          facingMode = facingMode === 'e' ? 'environment' : facingMode;
          facingMode = facingMode === 'u' ? 'user' : facingMode;
          allDevices.push({
            deviceId: device.deviceId,
            name: device.label,
            height: settings.height,
            width: settings.width,
            frameRate: Number(settings.frameRate.max),
            focusModes: settings.focusMode ?? [],
            torch: false,
            recommended: false,
            facingMode: facingMode,
          });
        } else {
          const capabilities: MediaTrackCapabilities | any = track.getCapabilities();
          let facingMode = capabilities.facingMode && capabilities.facingMode.length > 0 ? capabilities.facingMode[0] : '';
          facingMode = facingMode === 'e' ? 'environment' : facingMode;
          facingMode = facingMode === 'u' ? 'user' : facingMode;
          allDevices.push({
            deviceId: device.deviceId,
            name: device.label,
            height: capabilities.height.max,
            width: capabilities.width.max,
            frameRate: Number(capabilities.frameRate.max),
            focusModes: capabilities.focusMode ?? [],
            torch: capabilities.torch,
            recommended: false,
            facingMode: facingMode,
          });
        }
      });
      stream.getTracks().forEach(track => {
        track.stop();
      });
    }
    if (deviceInfo.browser.name === Browser.Safari && (deviceInfo.os.name === MobileOS.iOS || deviceInfo.os.name === MobileOS.MacOS)) {
      //@ts-ignore
      navigator.audioSession.type = 'playback';
    }

    if (allDevices.length > 0) {
      allDevices = allDevices.sort((a, b) => b.frameRate - a.frameRate);
      var firstOption = allDevices.find(i => i.focusModes.length > 1 && i.facingMode === 'environment');
      if (firstOption) {
        allDevices[allDevices.indexOf(firstOption)].recommended = true;
      } else {
        var firstEnv = allDevices.find(i => i.facingMode === 'environment');
        if (firstEnv) {
          allDevices[allDevices.indexOf(firstEnv)].recommended = true;
        }
      }
    }
    return allDevices;
  }

  public static GetConstraints(selectedDeviceId: string, device: DeviceInfo, portrait: boolean = false, audio: boolean = false): MediaStreamConstraints | any {
    let constraints: MediaStreamConstraints = {
      audio: audio,
    };

    let mediaTrack: MediaTrackConstraints = {
      frameRate: { ideal: 15, max: 20 },
    };

    if (selectedDeviceId) {
      mediaTrack.deviceId = {
        exact: selectedDeviceId,
      };
    }

    if (device.device.isDesktop) {
      mediaTrack.width = { ideal: 1280 };
    } else {
      if (portrait) {
        mediaTrack.facingMode = 'user';
        mediaTrack.width = { ideal: 1280, max: 1280 };
        //mediaTrack.height = { ideal: 720, max: 720 };
        //mediaTrack.aspectRatio = { ideal: 16 / 9, max: 16 / 9 };
      } else {
        mediaTrack.facingMode = 'environment';
        mediaTrack.width = { ideal: 720, max: 720 };
        mediaTrack.height = { ideal: 1280, max: 1280 };
        mediaTrack.aspectRatio = { ideal: 9 / 16, max: 9 / 16 };
      }
    }

    constraints.video = mediaTrack;
    return constraints;
  }

  static GetRecommendedCamera(cameras) {
    if (cameras && cameras.length > 0) {
      var recommDevice = cameras.find(c => c.recommended);
      if (recommDevice) {
        return recommDevice;
      }
    }

    return null;
  }

  public static async InitCameras(device: DeviceInfo): Promise<boolean> {
    LoggerService.log('cameras | initCameras');
    try {
      let cameras = await Cameras.GetCameras(device);

      LoggerService.log(`cameras | initCameras | cameras: ${JSON.stringify(cameras)}`);
      await ApiCall.instance.AddLog('cameras', cameras);

      let envCameras = cameras.filter(c => c.facingMode == 'environment');
      var recommCamera = Cameras.GetRecommendedCamera(envCameras);
      store.cameraIds = envCameras.map(camera => camera.deviceId);
      store.cameraId = recommCamera?.deviceId;
      return true;
    } catch (e) {
      LoggerService.log(e);
      if (e.message.includes('Permission denied') || e.name.includes('NotAllowedError')) {
        return false;
      }
      throw e;
    }
  }

  public static switchCamera() {
    let camIndex = store.cameraIds.indexOf(store.cameraId);
    let newCamId = camIndex === store.cameraIds.length - 1 ? store.cameraIds[0] : store.cameraIds[camIndex + 1];
    if (store.cameraId == newCamId) {
      store.cameraId = null;
    } else {
      store.cameraId = newCamId;
    }
  }
}
